/* Shared data & primitives used across all three dashboard variants */

const NAV_GROUPS = [
  {
    label: '交易中心',
    items: [
      { name: '交易紀錄', icon: 'file-text', active: true },
    ],
  },
  {
    label: '分析工具',
    items: [
      { name: '台股掃描器', icon: 'activity', ext: true, featured: true },
      { name: 'Deep Research', icon: 'search' },
      { name: '文件知識庫', icon: 'folder', featured: true },
    ],
  },
  {
    label: '企業服務',
    items: [
      { name: 'ERP 系統', icon: 'layout' },
      { name: '打卡鐘', icon: 'clock', ext: true },
      { name: '休假申請', icon: 'calendar', ext: true },
      { name: '報帳系統', icon: 'dollar-sign', ext: true },
      { name: '午餐點餐', icon: 'coffee', ext: true },
    ],
  },
  {
    label: '管理',
    items: [
      { name: '管理後台', icon: 'settings' },
    ],
  },
];

const QUICK_LINKS = ['信箱', '雲端', '白板', 'GitHub', '教學'];

/* Real-looking trader data */
const TRADERS = [
  { name: 'Mason',  pnl:  +284_500, lots: 42, trades: 18, win: 0.67 },
  { name: 'Peter',  pnl:  +162_800, lots: 31, trades: 22, win: 0.59 },
  { name: 'Jeff',   pnl:   +91_200, lots: 24, trades: 14, win: 0.64 },
  { name: 'Allen',  pnl:   +38_400, lots: 19, trades: 11, win: 0.55 },
  { name: 'Ken',    pnl:    -8_700, lots: 16, trades: 13, win: 0.46 },
  { name: 'Ryan',   pnl:   -24_300, lots: 12, trades:  9, win: 0.44 },
];

const POSITIONS = [
  { trader:'Mason', sym:'2330 台積電',    side:'B', lots:5, price:'1,045', ot:'10/22 09:02', pnl:+18_500, st:'holding', note:'破前高回測站穩,續多。' },
  { trader:'Peter', sym:'小台',           side:'S', lots:3, price:'22,185', ot:'10/22 09:05', pnl:+12_200, st:'closed',  note:'大盤開高,日內區間放空。' },
  { trader:'Mason', sym:'2454 聯發科',    side:'B', lots:2, price:'1,335', ot:'10/22 10:12', pnl: -3_400, st:'holding', note:'AI 題材延續,等回檔加碼。' },
  { trader:'Jeff',  sym:'2317 鴻海',      side:'B', lots:4, price:'  208', ot:'10/22 10:31', pnl: +9_600, st:'holding', note:'法人連買,突破年線。' },
  { trader:'Peter', sym:'3008 大立光',    side:'S', lots:1, price:'2,415', ot:'10/22 11:08', pnl: +4_800, st:'closed',  note:'財報利多出盡,日內放空。' },
  { trader:'Allen', sym:'2408 南亞科',    side:'B', lots:6, price:'   62.3', ot:'10/22 11:20', pnl: -2_100, st:'holding', note:'記憶體現貨價反彈。' },
  { trader:'Ken',   sym:'大台 12月',      side:'S', lots:2, price:'22,210', ot:'10/22 13:04', pnl: -5_500, st:'holding', note:'避險部位,留倉過夜。' },
  { trader:'Ryan',  sym:'2303 聯電',      side:'B', lots:3, price:'   52.8', ot:'10/22 13:42', pnl: +1_800, st:'closed',  note:'短線反彈做多。' },
];

/* Minimal feather-style icon resolver */
function Icon({ name, size = 16, stroke = 1.75, className = '' }) {
  const paths = {
    'file-text':  <><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></>,
    'activity':   <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>,
    'search':     <><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></>,
    'folder':     <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>,
    'book':       <><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></>,
    'github':     <><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"/></>,
    'layout':     <><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></>,
    'clock':      <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
    'calendar':   <><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></>,
    'dollar-sign':<><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></>,
    'coffee':     <><path d="M18 8h1a4 4 0 0 1 0 8h-1"/><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/></>,
    'settings':   <><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></>,
    'ext':        <><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></>,
    'plus':       <><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></>,
    'refresh':    <><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></>,
    'download':   <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></>,
    'mail':       <><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></>,
    'chevron-down': <polyline points="6 9 12 15 18 9"/>,
    'chevron-right':<polyline points="9 6 15 12 9 18"/>,
    'trending-up':<><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></>,
    'trending-down':<><polyline points="23 18 13.5 8.5 8.5 13.5 1 6"/><polyline points="17 18 23 18 23 12"/></>,
    'bell':       <><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></>,
    'message':    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>,
    'menu':       <><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></>,
    'log-out':    <><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></>,
    'key':        <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/>,
    'arrow-right':<><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></>,
    'filter':     <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>,
    'more':       <><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></>,
    'printer':    <><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></>,
    'user':       <><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></>,
    'edit':       <><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></>,
    'trash':      <><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></>,
    'check':      <polyline points="20 6 9 17 4 12"/>,
    'x':          <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>,
    'upload':     <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></>,
    // 側欄「功能分區」五個大主題圖示（hr-category-hub.jsx / TradingSidebar）
    'sun':        <><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></>,
    'bar-chart':  <path d="M18 20V10M12 20V4M6 20v-6"/>,
    'compass':    <><circle cx="12" cy="12" r="10"/><path d="M16.2 7.8l-2.1 6.3-6.3 2.1 2.1-6.3z"/></>,
    'tool':       <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>,
    'briefcase':  <><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></>,
    'arrow-up-right': <path d="M7 17L17 7M7 7h10v10"/>,
  };
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke="currentColor" strokeWidth={stroke}
      strokeLinecap="round" strokeLinejoin="round"
      className={className}
      style={{ flexShrink: 0 }}
    >
      {paths[name] || null}
    </svg>
  );
}

/* Tiny inline sparkline */
function Sparkline({ data, color = 'currentColor', width = 120, height = 32, fill = false }) {
  if (!data || data.length < 2) return null;
  const min = Math.min(...data), max = Math.max(...data);
  const range = max - min || 1;
  const step = width / (data.length - 1);
  const points = data.map((v, i) => [i * step, height - ((v - min) / range) * (height - 2) - 1]);
  const d = points.map((p, i) => (i === 0 ? `M${p[0]},${p[1]}` : `L${p[0]},${p[1]}`)).join(' ');
  const area = d + ` L${width},${height} L0,${height} Z`;
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display:'block' }}>
      {fill && <path d={area} fill={color} opacity="0.12" />}
      <path d={d} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/* Formatting */
const fmt = {
  pnl: (n) => (n >= 0 ? '+' : '−') + '$' + Math.abs(n).toLocaleString(),
  pct: (n) => (n * 100).toFixed(1) + '%',
};

/* Deterministic PRNG so sparklines are stable across variants */
function seededRandom(seed) {
  let s = seed;
  return () => {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
}

function makeSparkSeries(seed, len = 24, start = 0, drift = 0, noise = 1) {
  const r = seededRandom(seed);
  const arr = [start];
  for (let i = 1; i < len; i++) {
    arr.push(arr[i - 1] + drift + (r() - 0.5) * noise);
  }
  return arr;
}

/* ─────────────────────────  TimeSelect  ─────────────────────────
 * 時間下拉選擇器 — 取代難用的原生 time input。
 * 預設 00:00–23:45 每 15 分一格（24 小時全覆蓋），點選即填；選中項以 accent 標示並自動捲到中央。
 * 原本住在 hr-attendance.jsx（補打卡 modal / 月曆代補請假 modal），搬到 shared.jsx
 * 供 hr-leave.jsx 申請假勤表單共用。
 * 注意：內部引用的 HR / FontSizes / inputStyle 定義在較晚載入的 hr-shell.js 與
 * index.html inline script —— classic script 共用全域 scope，呼叫時才解析，載入順序無礙。
 */
function TimeSelect({ value, onChange, startHour = 0, endHour = 24, step = 15, placeholder = '— 選擇 —' }) {
  const [open, setOpen] = React.useState(false);
  // 下拉用 position:fixed + 視窗座標，避免被 Modal 的 overflow 裁切/撐出捲軸
  const [coords, setCoords] = React.useState(null);
  const wrapRef = React.useRef(null);
  const btnRef = React.useRef(null);
  const listRef = React.useRef(null);

  const computeCoords = React.useCallback(() => {
    const btn = btnRef.current;
    if (!btn) return;
    const r = btn.getBoundingClientRect();
    const margin = 8;
    const desired = 260;
    const spaceBelow = window.innerHeight - r.bottom - margin;
    const spaceAbove = r.top - margin;
    // 下方空間不足且上方較大 → 往上開
    const openUp = spaceBelow < Math.min(desired, 180) && spaceAbove > spaceBelow;
    const maxHeight = Math.max(140, Math.min(desired, openUp ? spaceAbove : spaceBelow));
    setCoords({
      left: r.left,
      width: r.width,
      openUp,
      top: openUp ? null : r.bottom + 4,
      bottom: openUp ? (window.innerHeight - r.top + 4) : null,
      maxHeight,
    });
  }, []);

  // 開啟時：量座標 + 綁 outside-click / 視窗 resize / 捲動（capture 以攔截 Modal 內捲動）重新定位
  React.useLayoutEffect(() => {
    if (!open) { setCoords(null); return; }
    computeCoords();
    const onDoc = (e) => { if (!wrapRef.current?.contains(e.target)) setOpen(false); };
    const onReposition = (e) => {
      // 忽略下拉自身的捲動，否則每次滾動都重算座標→觸發置中→把清單彈回，導致「滑不動」
      if (e && e.type === 'scroll' && listRef.current && listRef.current.contains(e.target)) return;
      computeCoords();
    };
    document.addEventListener('mousedown', onDoc);
    window.addEventListener('resize', onReposition);
    window.addEventListener('scroll', onReposition, true);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      window.removeEventListener('resize', onReposition);
      window.removeEventListener('scroll', onReposition, true);
    };
  }, [open, computeCoords]);

  const options = React.useMemo(() => {
    const out = [];
    // endHour 為排他上界：endHour=24 + step=15 → 最後一格 23:45
    for (let m = startHour * 60; m < endHour * 60; m += step) {
      out.push(`${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`);
    }
    return out;
  }, [startHour, endHour, step]);

  // 開啟後把選中項捲到下拉中央 —— 只做「一次」，之後使用者自行捲動不再被拉回
  const didCenterRef = React.useRef(false);
  React.useEffect(() => {
    if (!open) { didCenterRef.current = false; return; }
    if (coords && listRef.current && !didCenterRef.current) {
      const sel = listRef.current.querySelector('[data-sel="1"]');
      if (sel) listRef.current.scrollTop = sel.offsetTop - (listRef.current.clientHeight / 2) + (sel.clientHeight / 2);
      didCenterRef.current = true;
    }
  }, [open, coords]);

  return (
    <div ref={wrapRef} style={{ position: 'relative' }}>
      <button
        ref={btnRef}
        type="button"
        onClick={() => setOpen(o => !o)}
        style={{
          ...inputStyle({ fontFamily: HR.mono }),
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          cursor: 'pointer', textAlign: 'left',
          borderColor: open ? HR.accent : HR.rule,
        }}
      >
        <span style={{ color: value ? HR.ink : HR.inkFaint }}>{value || placeholder}</span>
        <span style={{
          color: HR.inkFaint, fontSize: 10, marginLeft: 8,
          transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .15s',
        }}>▾</span>
      </button>
      {open && coords && (
        <div ref={listRef} style={{
          position: 'fixed', left: coords.left, width: coords.width,
          ...(coords.openUp ? { bottom: coords.bottom } : { top: coords.top }),
          zIndex: 1100,
          background: HR.surface, border: `1px solid ${HR.rule}`, borderRadius: 5,
          boxShadow: '0 8px 24px rgba(0,0,0,0.14)', maxHeight: coords.maxHeight, overflowY: 'auto', padding: 4,
        }}>
          {options.map(t => {
            const isSel = t === value;
            return (
              <div
                key={t}
                data-sel={isSel ? '1' : '0'}
                onClick={() => { onChange(t); setOpen(false); }}
                style={{
                  padding: '7px 12px', fontSize: FontSizes.xs, fontFamily: HR.mono,
                  cursor: 'pointer', borderRadius: 4,
                  background: isSel ? HR.accentSoft : 'transparent',
                  color: isSel ? HR.accent : HR.ink,
                  fontWeight: isSel ? 600 : 400,
                }}
                onMouseEnter={(e) => { if (!isSel) e.currentTarget.style.background = HR.surfaceAlt; }}
                onMouseLeave={(e) => { if (!isSel) e.currentTarget.style.background = 'transparent'; }}
              >
                {t}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

Object.assign(window, { NAV_GROUPS, QUICK_LINKS, TRADERS, POSITIONS, Icon, Sparkline, fmt, makeSparkSeries, TimeSelect });
